import { MealPlanType } from '@woolworthsnz/trader-api';

export function mapToDietaryRequirementOptions(
	mealPlanTypeList: MealPlanType[]
): { key: number; text: string; description: string }[] {
	return mealPlanTypeList.map((mealPlanType) => ({
		key: mealPlanType.id || 0,
		text: mealPlanType.name || '',
		description: mealPlanType.description || '',
	}));
}
